try{self['workbox:range-requests:4.3.1']&&_()}catch(e){}// eslint-disable-line